import {
    type FC,
    type Dispatch,
    type ReactNode,
    type SetStateAction,
    useMemo,
    useState,
    useContext,
    createContext,
} from 'react';

type PdpRespMarketplaceStickyHeaderContextType = {
    showStickyHeader: boolean;
    setShowStickyHeader: Dispatch<SetStateAction<boolean>>;
};

type Props = {
    children: ReactNode;
};

export const PdpRespMarketplaceStickyHeaderContext =
    createContext<PdpRespMarketplaceStickyHeaderContextType>({
        showStickyHeader: false,
        setShowStickyHeader: () => {},
    });

export const PdpRespMarketplaceStickyHeaderContextProvider: FC<Props> = ({ children }) => {
    const [showStickyHeader, setShowStickyHeader] = useState(true);

    return (
        <PdpRespMarketplaceStickyHeaderContext.Provider
            value={useMemo(
                () => ({ setShowStickyHeader, showStickyHeader }),
                [setShowStickyHeader, showStickyHeader]
            )}
        >
            {children}
        </PdpRespMarketplaceStickyHeaderContext.Provider>
    );
};
export const useStickyHeaderContext = (): PdpRespMarketplaceStickyHeaderContextType =>
    useContext<PdpRespMarketplaceStickyHeaderContextType>(PdpRespMarketplaceStickyHeaderContext);
